<template>
  <v-container fluid full-height grid-list-md>
    <v-layout row wrap>
      <v-flex xs6>
        <div class="text-xs-left">
          <v-breadcrumbs :items="breadcrumbs" divider=">"></v-breadcrumbs>
        </div>
      </v-flex>
      <v-flex xs6 v-if="user.role.roleName == 'SALE_MANAGER'">
        <div class="text-xs-right">
          <v-btn color="primary" @click="onRegister">
            New Denomination
            <v-icon right>add_circle</v-icon>
          </v-btn>
        </div>
      </v-flex>
      <v-flex xs12>
        <v-card>
          <v-layout row wrap class="pa-3">
            <v-flex sm4>
              <v-menu
                :nudge-right="40"
                lazy
                transition="scale-transition"
                offset-y
                full-width
                min-width="290px"
              >
                <v-text-field
                  slot="activator"
                  v-model="queryParams.fromDate"
                  label="From Date"
                  prepend-icon="event"
                  readonly
                ></v-text-field>
                <v-date-picker v-model="queryParams.fromDate"></v-date-picker>
              </v-menu>
            </v-flex>
            <v-flex sm4>
              <v-menu
                :nudge-right="40"
                lazy
                transition="scale-transition"
                offset-y
                full-width
                min-width="290px"
              >
                <v-text-field
                  slot="activator"
                  v-model="queryParams.toDate"
                  label="To Date"
                  prepend-icon="event"
                  readonly
                ></v-text-field>
                <v-date-picker v-model="queryParams.toDate"></v-date-picker>
              </v-menu>
            </v-flex>
            <v-flex sm4 v-if="user.role.roleName == 'ADMIN' || user.role.roleName == 'BRANCH_ADMIN'">
              <v-select
                :items="shopList"
                label="Choose Shop..."
                item-text="name"
                menu-props="auto"
                item-value="id"
                v-model="queryParams.shopId"
              ></v-select>
            </v-flex>
            <v-flex sm4>
              <v-autocomplete 
                v-model="queryParams.currencyId"
                :items="currencyList"
                color="blue-grey lighten-2"
                label="Choose Currency..."
                item-text="code"
                menu-props="auto"
                item-value="id"
              ></v-autocomplete>
            </v-flex>
            <v-flex sm3>
              <v-select
                :items="typeList"
                label="Type"
                v-model="queryParams.type"
                item-text="label"
                item-value="value"
              ></v-select>
            </v-flex>
            <v-flex sm3>
              <v-text-field
                name="issueNo"
                label="Issue No"
                type="text"
                v-model="queryParams.issueNo"
              ></v-text-field>
            </v-flex>
            <v-flex sm3>
              <v-select
                :items="statusList"
                label="Status"
                v-model="queryParams.status"
                item-text="label"
                item-value="value"
              ></v-select>
            </v-flex>
            <v-flex sm3>
              <v-btn outline color="primary" @click="onSearch">
                Search
                <v-icon right>search</v-icon>
              </v-btn>
            </v-flex>
            <v-flex xs12>
              <v-card>
                <v-card-title class="blue darken-3">
                  <span class="headline white--text">Summary</span>
                </v-card-title>
                <v-card-text class="font-weight-bold">
                  <div>
                    <v-btn
                      :loading="buttonLoading"
                      color="primary"
                      @click="printAllDenomination('printDenomination')"
                      >PRINT ALL</v-btn
                    >
                    <v-btn
                      :loading="buttonLoading"
                      color="success"
                      @click="exportAllDenomination()"
                      >EXPORT ALL</v-btn
                    >
                  </div>
                  <div>
                    <span>Total Cash Amount:</span>
                    <v-chip>
                      <span>{{ totalCashAmount | decFormat }}</span>
                    </v-chip>
                    <span>Total K Pay Amount:</span>
                    <v-chip>
                      <span>{{ totalKPayAmount | decFormat }}</span>
                    </v-chip>
                    <span>Total Bank Transfer Amount:</span>
                    <v-chip>
                      <span>{{ totalBankTransferAmount | decFormat }}</span>
                    </v-chip>
                  </div>
                </v-card-text>
              </v-card>
            </v-flex>
            <v-flex xs12 class="mt-1">
              <v-card>
                <v-data-table
                  :headers="headers"
                  :items="denominationList"
                  class="elevation-1"
                  :loading="showListLoading"
                  :total-items="totalRows"
                  :rows-per-page-items="rowsPerPageItems"
                  :pagination.sync="pagination"
                  :must-sort="true"
                >
                  <template slot="items" slot-scope="props">
                    <td>
                      {{
                        props.item.issueDateInMilliSeconds
                          | format-ms-date
                      }}
                    </td>
                    <td>{{ props.item.issueNo }}</td>
                    <td>{{ props.item.shop.name }}</td>
                    <td v-if="props.item.type == 'CASH_SALE'">
                      {{ props.item.type }}
                    </td>
                    <td v-if="props.item.type == 'CREDIT_SALE'">
                      {{ props.item.type }}(CASH RECEIVE)
                    </td>
                    <td>{{ props.item.currencyName }}</td>
                    <td>{{ props.item.cashAmount | decFormat }}</td>
                    <td>{{ props.item.kpayAmount | decFormat }}</td>
                    <td>{{ props.item.bankTransferAmount | decFormat }}</td>
                    <td>{{ props.item.description }}</td>
                    <td>{{ props.item.status }}</td>
                    <td v-if="user.role.roleName == 'SALE_MANAGER'">
                      <v-btn
                        flat
                        icon
                        color="blue lighten-2"
                        @click="onEdit(props.item)"
                      >
                        <v-icon>edit</v-icon>
                      </v-btn>
                    </td>
                  </template>
                </v-data-table>
              </v-card>
            </v-flex>
          </v-layout>
        </v-card>
      </v-flex>
    </v-layout>
    <!--print all-->
    <div
      id="printDenomination"
      style="bsale: 1px solid black; width: 300px"
      v-show="false"
    >
      <div style="text-align: center">
        <p style="font-size: 18px; margin: 1px; font-weight: bold">
          Denomination
        </p>
      </div>
      <div style="text-align: center">
        <p style="font-size: 18px; margin: 1px; font-weight: bold">
          From: [{{ queryParams.fromDate }}] To: [{{ queryParams.toDate }}]
        </p>
      </div>
      <br />
      <div style="padding-left: 5px; padding-right: 5px">
        <table
          style="
            font-family: arial, sans-serif;
            border-collapse: collapse;
            width: 100%;
            font-size: 11px;
            border-top: 1px solid black;
          "
        >
          <thead>
            <th style="border: 1px solid black">Issue Date</th>
            <th style="border: 1px solid black">Issue No</th>
            <th style="border: 1px solid black">Shop</th>
            <th style="border: 1px solid black">Type</th>
            <th style="border: 1px solid black">Currency</th>
            <th style="border: 1px solid black">Description</th>
            <th style="border: 1px solid black">Cash Amount</th>
            <th style="border: 1px solid black">K Pay Amount</th>
            <th style="border: 1px solid black">Bank Transfer Amount</th>
          </thead>
          <tbody>
            <tr v-for="(item, index) in allDenominationList" :key="index">
              <td style="border: 1px solid black">
                {{ item.issueDateInMilliSeconds | format-year-to-day-date }}
              </td>
              <td style="border: 1px solid black">{{ item.issueNo }}</td>
              <td style="border: 1px solid black">{{ item.shop.name }}</td>
              <td
                style="border: 1px solid black"
                v-if="item.type == 'CASH_SALE'"
              >
                {{ item.type }}
              </td>
              <td
                style="border: 1px solid black"
                v-if="item.type == 'CREDIT_SALE'"
              >
                {{ item.type }}(CASH RECEIVE)
              </td>
              <td style="border: 1px solid black">{{ item.currencyName }}</td>
              <td style="border: 1px solid black">{{ item.description }}</td>
              <td style="border: 1px solid black; text-align: right">
                {{ item.cashAmount | decFormat }}
              </td>
              <td style="border: 1px solid black; text-align: right">
                {{ item.kpayAmount | decFormat }}
              </td>
              <td style="border: 1px solid black; text-align: right">
                {{ item.bankTransferAmount | decFormat }}
              </td>
            </tr>
            <tr>
              <td
                colspan="6"
                style="text-align: right; border: 1px solid black"
              >
                Total
              </td>
              <td style="text-align: right; border: 1px solid black">
                {{ printTotalCashAmount | decFormat }}
              </td>
              <td style="text-align: right; border: 1px solid black">
                {{ printTotalKPayAmount | decFormat }}
              </td>
              <td style="text-align: right; border: 1px solid black">
                {{ printTotalBankTransferAmount | decFormat }}
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
    <!--end print all--->
  </v-container>
</template>

<script>
import { denominationService } from "../../services/denomination-service";
import { commonService } from "../../services/common-service";
import { shopService } from "../../services/shop-service";
import { currencyService } from '../../services/currency-service';

export default {
  name: "DenominationList",
  components: {},
  data: () => ({
    user: JSON.parse(localStorage.getItem("user")),
    showListLoading: false,
    buttonLoading: false,
    breadcrumbs: [
      {
        text: "Counter Cash",
        disabled: true,
      },
      {
        text: "Denomination",
        disabled: true,
      },
    ],
    headers: [
      { text: "Issue Date", align: "left", value: "issueDate" },
      { text: "Issue No", value: "issueNo" },
      { text: "Shop", value: "shop.name" },
      { text: "Type", value: "type" },
      { text: "Currency", value: "currencyName" },
      { text: "Cash Amount", value: "cashAmount" },
      { text: "K Pay Amount", value: "kpayAmount" },
      { text: "Bank Transfer Amount", value: "bankTransferAmount" },
      { text: "Description", value: "description" },
      { text: "Status", value: "status" },
      { text: "Action", value: "name", sortable: false },
    ],
    rowsPerPageItems: [25, 50, 100],
    pagination: {
      descending: true,
      page: 1,
      rowsPerPage: 50,
      sortBy: "issueDate",
      totalItems: 0,
    },
    totalRows: 0,
    queryParams: {
      fromDate: commonService.formatDate(new Date(), "YYYY-MM-DD"),
      toDate: commonService.formatDate(new Date(), "YYYY-MM-DD"),
      shopId: "",
      type: "",
      issueNo: "",
      status: "",
      currencyId: "",
    },
    statusList: [
      { label: "ALL", value: "" },
      { label: "DRAFT", value: "DRAFT" },
      { label: "CONFIRM", value: "CONFIRM" },
      { label: "CANCEL", value: "CANCEL" },
    ],
    typeList: [
      { label: "ALL", value: "" },
      { label: "CASH SALE", value: "CASH_SALE" },
      { label: "CREDIT SALE(CASH RECEIVE)", value: "CREDIT_SALE" },
    ],
    currencyList: [],
    denominationList: [],
    allDenominationList: [],
    shopList: [],
    totalCashAmount: 0,
    totalKPayAmount: 0,
    totalBankTransferAmount: 0,
    printTotalCashAmount: 0,
    printTotalKPayAmount: 0,
    printTotalBankTransferAmount: 0,
  }),
  watch: {
    pagination: {
      handler() {
        this.getDenominationList();
      },
      deep: true,
    },
  },
  created() {
    //for deep linking
    if (this.$route.query.fromDate) {
      this.queryParams.fromDate = this.$route.query.fromDate;
    }
    if (this.$route.query.toDate) {
      this.queryParams.toDate = this.$route.query.toDate;
    }
    if (this.$route.query.shopId) {
      this.queryParams.shopId = this.$route.query.shopId;
    }
    if (this.$route.query.type) {
      this.queryParams.type = this.$route.query.type;
    }
    if (this.$route.query.currencyId) {
      this.queryParams.currencyId = this.$route.query.currencyId;
    }
    if (this.$route.query.issueNo) {
      this.queryParams.issueNo = this.$route.query.issueNo;
    }
    if (this.$route.query.status) {
      this.queryParams.status = this.$route.query.status;
    }
    if (this.$route.query.page) {
      this.pagination.page = this.$route.query.page;
    }
    if (this.$route.query.size) {
      this.pagination.size = this.$route.query.size;
    }
    this.getAllShop();
    this.getActiveCurrency()
    .finally(() => {
        this.onSearch();
    });
  },
  methods: {
    getAllShop() {
      shopService
        .getAllShop()
        .then((res) => {
          this.shopList = res.data;
          let findAll = { id: "", name: "---All---" };
          this.shopList.splice(0, 0, JSON.parse(JSON.stringify(findAll)));
        })
        .catch((err) => {
          console.log(err);
        });
    },
    onSearch() {
      this.queryParams.page = this.pagination.page;
      this.queryParams.size = this.pagination.rowsPerPage;
      this.$router.replace({ name: "denominations", query: this.queryParams });
      this.getDenominationList();
    },
    getDenominationList() {
      this.totalCashAmount = 0.0;
      this.totalKPayAmount = 0.0;
      this.totalBankTransferAmount = 0.0;
      this.showListLoading = true;
      let order = this.pagination.descending ? "desc" : "asc";
      denominationService
        .getDenominationList(
          this.queryParams,
          this.pagination.page,
          this.pagination.rowsPerPage,
          this.pagination.sortBy + "," + order
        )
        .then((res) => {
          if (res.data) {
            this.denominationList = res.data.denominationList;
            this.totalRows = res.data.totalElements;
            this.totalCashAmount = res.data.totalCashAmount;
            this.totalKPayAmount = res.data.totalKPayAmount;
            this.totalBankTransferAmount = res.data.totalBankTransferAmount;
          }
        })
        .catch((err) => {
          console.log(err);
        })
        .finally(() => {
          this.showListLoading = false;
        });
    },
    onRegister() {
      this.$router.push("/denomination/new");
    },
    onEdit(denomination) {
      // go to details page
      this.$router.push("/denomination/" + denomination.id);
    },
    getActiveCurrency(){
      return currencyService.getCurrencyByStatus('ACTIVE')
      .then(res => {
        if(res.data){
          this.currencyList = res.data;
          let c = commonService.search("defaultCurrency",true,this.currencyList);
          if(c){
            this.queryParams.currencyId = c.id;
          }
        }
      })
      .catch((err) => {
        console.log(err);
      });
    },
    printAllDenomination(divName) {
      this.printTotalCashAmount = 0.0;
      this.printTotalKPayAmount = 0.0;
      this.printTotalBankTransferAmount = 0.0;
      this.buttonLoading = true;
      denominationService
        .getDenominationListForPrint(this.queryParams)
        .then((res) => {
          if (res.data) {
            this.allDenominationList = res.data.denominationList;
            this.printTotalCashAmount = res.data.totalCashAmount;
            this.printTotalKPayAmount = res.data.totalKPayAmount;
            this.printTotalBankTransferAmount = res.data.totalBankTransferAmount;
          }
        })
        .catch((err) => {
          console.log(err);
        })
        .finally(() => {
          let printContents = document.getElementById(divName).innerHTML;
          let reprintWindow = window.open(
            "",
            "MsgWindow",
            "width:500;height:500"
          );
          reprintWindow.document.write(printContents);
          setTimeout(() => {
            reprintWindow.print(), reprintWindow.close();
          }, 600);
          this.buttonLoading = false;
        });
    },
    exportAllDenomination() {
      this.buttonLoading = true;
      denominationService
        .getDenominationExcelExport(this.queryParams)
        .then((res) => {
          commonService.downloadE(res);
        })
        .catch((err) => {
          console.log(err);
        })
        .finally(() => {
          this.buttonLoading = false;
        });
    },
  },
};
</script>
